import type { StripeInvoiceInfo } from '@racemap/utilities/types/events';
import { Button } from 'antd';
import { AsyncButton } from 'src/components/AsyncButton';
import { HStack } from '../../BasicComponents/MetaComponent/index';
import type { ViewSlots } from './useOverviewView';

interface Args {
  info: StripeInvoiceInfo | null;
  error: string | null;
  onClose: () => void;
  onRetry: () => Promise<void>;
}

export const useStatusView = ({ info, error, onClose, onRetry }: Args): ViewSlots => {
  const invoiceUrl = error == null && info?.status === 'OPEN' ? info.invoiceUrl : undefined;

  return {
    title: error != null ? 'Payment status unavailable' : 'Payment pending',
    body: <p>{getMessage(info, error)}</p>,
    footer: (
      <HStack gap="5px">
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
        {invoiceUrl != null && (
          <Button href={invoiceUrl} target="_blank" rel="noreferrer noopener">
            Pay open invoice
          </Button>
        )}
        <AsyncButton type="primary" onClick={onRetry}>
          Check again
        </AsyncButton>
      </HStack>
    ),
  };
};

const getMessage = (info: StripeInvoiceInfo | null, error: string | null) => {
  if (error != null) return `We could not check the payment of this event: ${error}`;
  if (info?.status === 'OPEN')
    return 'An invoice for this event is still open. Pay it to activate the event.';
  return 'Your payment is being processed. The event activates once it is complete.';
};
